<template>
  <TopGradientBlockLayout style="height: auto;">
    <div class="grid grid-cols-11 col-gap-3 items-end mb-4">
      <div class="col-span-5 text-xl text-text font-bold">{{ $t('incomeTitle') }}</div>
      <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('plan') }}</div>
      <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('fact') }}</div>
      <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('difference') }}</div>
    </div>
    <div>
      <BudgetItem v-for="(incomeBudget,i) in incomes" :key="'income-'+i"
                  v-bind="budgetIncomeProps(incomeBudget)"
                  @select="selectBudget(incomeBudget)"/>
    </div>
    <template v-if="goalDebitBudgets.length || goalCreditBudgets.length">
      <div class="grid grid-cols-11 col-gap-3 items-end mt-12 mb-4">
        <div class="col-span-5 text-xl text-text font-bold">{{ $t('goalsTitle') }}</div>
        <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('plan') }}</div>
        <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('fact') }}</div>
        <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('difference') }}</div>
      </div>
      <div>
        <BudgetItem v-for="(goalDebitBudget,i) in goalDebitBudgets"
                    v-bind="budgetGoalProps(goalDebitBudget)"
                    @select="selectBudget(goalDebitBudget)"
                    :key="'goal-debit-'+i"/>
        <BudgetItem v-for="(goalCreditBudget,i) in goalCreditBudgets"
                    v-bind="budgetGoalProps(goalCreditBudget)"
                    @select="selectBudget(goalCreditBudget)"
                    :key="'goal-credit-'+i"/>
      </div>
    </template>

    <div class="grid grid-cols-11 col-gap-3 items-end mt-12 mb-4">
      <div class="col-span-5 text-xl text-text font-bold">{{ $t('expenseTitle') }}</div>
      <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('plan') }}</div>
      <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('fact') }}</div>
      <div class="col-span-2 text-text-ternary text-2sm text-right">{{ $t('difference') }}</div>
    </div>
    <BudgetGroupItem v-for="(item,i) in expenseGroupsWithChilds"
                     :group="item"
                     @select="selectBudget($event)"
                     :key="'expense-'+i"/>
    <BudgetItem v-for="(expenseBudget,i) in expensesWOGroup" :key="'expense-wo-group-'+i"
                v-bind="budgetExpenseProps(expenseBudget)"
                @select="selectBudget(expenseBudget)"/>
  </TopGradientBlockLayout>
</template>

<script>

import {mapActions, mapGetters, mapState} from "vuex";
import BudgetItem from "@/components/cabinet/Money/Budgets/BugetItem/BudgetItem";
import BudgetGroupItem from "@/components/cabinet/Money/Budgets/BugetItem/BudgetItemGroup";
import TopGradientBlockLayout from "@/components/layouts/cabinet/TopGradientBlockLayout";

export default {
  name: "BudgetView",
  components: {TopGradientBlockLayout, BudgetGroupItem, BudgetItem},
  computed: {
    ...mapGetters('space/budgets', [
          'incomes',
          'expensesGroups',
          'expensesWOGroup',
          'goalCreditBudgets',
          'goalDebitBudgets',
          'budgetCommonProps',
          'budgetIncomeProps',
          'budgetExpenseProps',
          'budgetGoalProps',
        ]
    ),
    expenseGroupsWithChilds() {
      return [...this.expensesGroups].filter(group => group.childs.length)
    },
  },
  methods: {
    ...mapActions('space/budgets', ['selectBudget']),
  },
  i18n: {
    messages: {
      en: {
        incomeTitle: 'Incomes',
        expenseTitle: 'Expenses',
        goalsTitle: 'Goals',
        plan: 'Plan',
        fact: 'Fact',
        difference: 'Difference'
      },
      ru: {
        incomeTitle: 'Доходы',
        expenseTitle: 'Расходы',
        goalsTitle: 'Цели',
        plan: 'План',
        fact: 'Факт',
        difference: 'Разница'
      }
    }
  }
}
</script>